<app-conversation-picker
  [message]="dialogData.message"
  [header]="dialogData.header"
  [createNewConversationButtonText]="dialogData.createNewConversationButtonText"
  [sendButtonText]="dialogData.sendButtonText"
  [patientUids]="dialogData.patientUids"
  [attached]="dialogData.attachments"
  [attachmentType]="dialogData.attachmentType"
></app-conversation-picker>
